<script>
import {
  BTabs,
  BTab,
  BCard,
  BCardText,
} from 'bootstrap-vue';

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BCardText,
  },

  // eslint-disable-next-line global-require
  props: ['user', 'tabless'],

  created () {
    this.tabIndex = this.tabs.findIndex((tab) => tab === window.location.hash);
  },

  mounted () {
    this.getToken();
  },

  data () {
    return {
      tabIndex: 0,
      tabs: [
        '#/nav-general',
        '#/nav-custom-fields',
        '#/nav-status',
        '#/nav-won-reason',
        '#/nav-lost-reason',
        '#/nav-origin',
        '#/nav-domains',
        '#/nav-sales-funnel',
        '#/nav-credits',
        '#/nav-forms-integration',
      ],
      token: null,
    };
  },

  watch: {
    tabIndex () {
      const view = this.tabs[this.tabIndex];

      if (view) {
        window.location.hash = view;
      }
    },
  },

  methods: {
    submit () {
      document.querySelector('#form-params').submit();

      return false;
    },

    getToken () {
      this.$http.get('/settings/token')
        .then((response) => {
          this.token = response.data;
        });
    },

    generateToken () {
      this.$http.post('/settings/token/generate')
        .then((response) => {
          this.token = response.data;

          location.reload();
        });
    },

    redirectTo (url) {
      window.location.href = url;
    }
  },
};
</script>

<style lang="scss" soped>
  .col-2.tabs-container {
    background-color: #F4F2F7;
  }
</style>
